import React, { useState, useEffect, useRef } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import SearchIcon from "@mui/icons-material/Search";
import CachedImage from "../../../../common/CachedImage";

import { useSelector } from "react-redux";
import { Mandatory } from "../../FormHelpers";
import {
	BootstrapTooltip, FormContainer, InputAdornmentContainer, LookUpDropCustom,
	ProperContainer, TextFieldContainer
} from "./Styled";
import { ImagePath } from "../../../../../assets/ImagePath";


const PopperMy = function (props) {
	return <ProperContainer {...props} placement="bottom-start" />;
};

let searchedId = null;

const LookupInput = (props) => {
	const {
		id,
		name,
		info,
		readOnly,
		value,
		handleChange,
		onBlurField,
		onSelectField,
		mandatory,
		placeholder,
		maxLength,
		minLength,
		validation,
		validationResult,
		validationMessage,
		results,
		title,
		islabelvisible,
		isSearchedFrontedKey,
		activeLookupId,
		setActiveLookupId
	} = props;

	const [open, setOpen] = useState(false);
	const [inputValue, setInputValue] = useState(value);
	const [isSearching, setIsSearching] = useState(false);
	const [defaultValue, setDefaultValue] = useState([]);

	const botWaitLoader = useSelector((state) => state.loader?.botWaitLoaderWithShimmerOnly);
	const lookupField = useRef(null);

	useEffect(() => {
		if (inputValue && activeLookupId && (activeLookupId === id)
			|| ((results && results !== undefined && results.length > 0)) && inputValue && (searchedId === id)) {
			setOpen(true);
			searchedId = null
		}
	}, [activeLookupId, searchedId, results])


	useEffect(() => {
		if (Object.prototype.toString.call(value) === "[object Object]") {
			const val = {
				text: value?.text?.toString() || "",
				info: value?.info?.toString() || "",
			};
			setDefaultValue(val);
			return;
		}
		if (value) {
			setDefaultValue({
				text: value?.toString() || "",
				info: value?.toString() || "",
			});
		} else if (value === "") {
			setDefaultValue({ text: "", info: "" });
		}
		if (!botWaitLoader) {
			setIsSearching(false);
		}
	}, [value, botWaitLoader]);


	// close on outside click
	useEffect(() => {
		function handleClickOutside(event) {
			const listbox = document.querySelector(".MuiAutocomplete-popper");
			if (
				lookupField.current &&
				!lookupField.current.contains(event.target) &&
				!(listbox && listbox.contains(event.target))
			) {
				setOpen(false);
				setActiveLookupId(null);
				searchedId = null
			}
		}
		document.addEventListener("click", handleClickOutside, true);
		return () => {
			document.removeEventListener("click", handleClickOutside, true);
		};
	}, []);


	const handleSearchInput = (e) => {
		if (e.key === "Enter" && e.target.value && !!e.target.value.trim().length) {
			handleChange(e);
			onBlurField(e, "search");
			setIsSearching(true);
			setActiveLookupId(null);
			searchedId = id
		}
	};

	const isBoolean = (val) => "boolean" === typeof val;

	return (
		<div className="relative flex items-start gap-1 update-input">
			<div className="w-full">
				<div className="flex items-center gap-1 mb-[5px]">
					{!islabelvisible && <span className="min-w-[17px] h-[17px] rounded-7 flex items-center justify-center">
						<CachedImage
							image={ImagePath.searchInputField}
							imgKey="search-input-field"
							className="w-[17px] h-[17px]"
						/>
					</span>}
					{!islabelvisible && <label className="text-size-14 text-[#15194B] font-regular mt-[2px]">
						{title}{mandatory && <Mandatory {...props} />}
					</label>}
				</div>
				<div className="relative">
					<FormContainer
						islabelvisible={islabelvisible}
						PopperComponent={PopperMy}
						open={open}
						size="small"
						id={id}
						name={id}
						autoHighlight={true}
						onFocus={() => setActiveLookupId(id)}
						onOpen={() => {
							if (((inputValue === "" || inputValue == undefined))) {
								setActiveLookupId(null)
							}
							else if (inputValue && isSearchedFrontedKey) {
								setActiveLookupId(id)
							}
						}}
						onClose={() => setActiveLookupId(null)}
						options={results || []}
						noOptionsText="No results found"
						getOptionLabel={(option) => option.text || ""}
						isOptionEqualToValue={(option, value) => option.text === value.text}
						value={defaultValue}
						onChange={(event, value, reason) => {
							if (value) {
								setInputValue(value.text || "");
								setDefaultValue(value);
								handleChange(
									{ target: { name: id } },
									"lookup",
									value.text || ""
								);
								onSelectField(id, value);
								setOpen(false);
								setActiveLookupId(null);
							}

							if (reason === "clear") {
								setDefaultValue([]);
								setInputValue("");
								handleChange({ target: { name: id } }, "lookup", "");
								onSelectField(id, { text: "", info: "" });
								setOpen(false);
								setActiveLookupId(null)
							}
						}}

						disabled={readOnly || isSearching}
						disableClearable={!inputValue}
						renderOption={(props, option) => {
							const info = option?.info;
							let rowsOfInfo, toolTipJsx, shudToolTipRender;
							const { key, ...rest } = props;

							if (Object.prototype.toString.call(info) === "[object Object]") {
								rowsOfInfo = Object.entries(info)
									.map(([key, val]) =>
										["[object String]", "[object Number]"].includes(
											Object.prototype.toString.call(val)
										) ? (
											<tr>{[<td>{key}</td>, <td>{val}</td>]}</tr>
										) : null
									)
									.filter((itm) => itm !== null);

								toolTipJsx = (
									<table style={{ borderSpacing: "1px" }}>{rowsOfInfo}</table>
								);
								shudToolTipRender = !!rowsOfInfo.length;
							} else if (Object.prototype.toString.call(info) === "[object String]") {
								toolTipJsx = info;
								shudToolTipRender = !!info;
							} else {
								toolTipJsx = "";
								shudToolTipRender = false;
							}

							return (
								<LookUpDropCustom
									key={key}
									shudtooltiprender={shudToolTipRender}
									{...rest}
								>
									<span>{option.text}</span>
									{shudToolTipRender && (
										<BootstrapTooltip title={toolTipJsx} arrow>
											<InfoOutlinedIcon sx={{ color: "#98b0c8", fontSize: 20 }} />
										</BootstrapTooltip>
									)}
								</LookUpDropCustom>
							);
						}}
						renderInput={(params) => (
							<TextFieldContainer
								{...params}
								variant="outlined"
								id={id}
								value={inputValue}
								name={id}
								ref={lookupField}
								onKeyDown={handleSearchInput}
								onChange={(e) => setInputValue(e.target.value)}
								InputProps={{
									...params.InputProps,
									autoComplete: "new-password",
									endAdornment: (
										<>
											{isSearching ? (
												<CircularProgress color="inherit" size={20} />
											) : (
												<InputAdornmentContainer position="end">
													<SearchIcon
														onClick={() => {
															if (
																lookupField.current &&
																lookupField.current.children[0] &&
																lookupField.current.children[0].children[0] &&
																lookupField.current.children[0].children[0]
																	.localName === "input"
															) {
																handleSearchInput({
																	key: "Enter",
																	target: {
																		name: lookupField.current.children[0].children[0]
																			.name,
																		value:
																			lookupField.current.children[0].children[0]
																				.value,
																	},
																});
															} else if (
																lookupField.current &&
																lookupField.current.children[1] &&
																lookupField.current.children[1].children[0] &&
																lookupField.current.children[1].children[0]
																	.localName === "input"
															) {
																handleSearchInput({
																	key: "Enter",
																	target: {
																		name: lookupField.current.children[1].children[0]
																			.name,
																		value:
																			lookupField.current.children[1].children[0]
																				.value,
																	},
																});
															}
														}}
													/>
												</InputAdornmentContainer>
											)}
										</>
									),
								}}
								helperText={
									!props.inline &&
									(isBoolean(validationResult) && !validationResult
										? validationMessage
										: info)
								}
								error={
									validation && isBoolean(validationResult)
										? !validationResult
										: false
								}
							/>
						)}
					/>
				</div>
			</div>
		</div>
	);
};
export default LookupInput;
